import { UtilityService } from '@eforall/common';
import { buildColumn, GridColumn } from '@eforall/dashboard';
import { LanguageId, VolunteerSignupSpecialistTopic } from '@interfaces';


export function getColumns(util: UtilityService) {
	const columns: GridColumn<VolunteerSignupSpecialistTopic & { updatedUTC: number }, unknown>[] = [
		buildColumn(util, 'FullName', row => row.topicName, {
			header: 'Topic', group: 'asc', width: 150
		}),
		buildColumn(util, 'Text', row => util.text.titleCase(row.volunteerSignupSpecialistStatus), { header: 'Status', width: 60 }),
		buildColumn(util, 'Text', row => util.date.formatUTC(row.availableClassStartTimeUTC, 'DOW MMM D, YYYY', 'H:MM AM EST', 'en-US'), { header: 'Event Start' }),
		buildColumn(util, 'Text', row => util.date.formatUTC(row.availableClassEndTimeUTC, 'DOW MMM D, YYYY', 'H:MM AM EST', 'en-US'), { header: 'Event End' }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.English ? 'English' : 'Spanish', { header: 'Language', width: 60 }),
	];
	return columns;

}
